import "../../styles/header.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faHouse, faNetworkWired, faUsers, faDropletSlash, faChartColumn, faTools, faFaucet, faHouseWater, faBridgeWater } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/imgs/giwasco_logo.png"
import { useState, useEffect } from "react";
import Dropdown from ".././dropdown";

export default function GISHeader (props) {
    const [isSlightlyScrolled, setIsSlightlyScrolled] = useState(false);
    const [isScrolledByVh, setIsScrolledByVh] = useState(false);
    const [toggleName, setToggleName] = useState(window.innerWidth > 768);
    const [toggleNavLinks, setToggleNavlinks] = useState(false);

    const navItems = [
        { name: "Home", icon: faHouse, path: "/" },
        { name: "Infrastructure", icon: faFaucet, path: "/infrastructure" },
        { name: "Customers", icon: faUsers, path: "/customers" },
        { name: "NRW", icon: faDropletSlash, path: "/nrw" },
        { name: "Reports", icon: faChartColumn, path: "/reports" }
    ];

    useEffect(() => {
        const handleContextMenu = (e) => {
        e.preventDefault();
        };

        document.addEventListener('contextmenu', handleContextMenu);

        return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    return (
        <div className= "header">
            <div className="gisnavigation">
                <div className={toggleName ? "logo bg_primary" : "logo"}>
                    <img src={logo} alt="" onClick={() => setToggleName(!toggleName)}/>
                    {toggleName && <h1>Githunguri Water GIS Portal</h1>}
                </div>
                {toggleNavLinks ? <div className="navlinks">
                    {/* <a href="/">Home</a>
                    <a href="/infrastructure">Infrastructure</a>
                    <a href="/cis">CIS</a>
                    <a href="/incidences">Incidences</a>
                    <a href="/reports">Reports</a> */}
                    {navItems.map(item => (
                        <a href={item.path} key={item.name} className="nav-item">
                        <FontAwesomeIcon icon={item.icon} />
                        <span className="tooltip">{item.name}</span>
                        </a>
                    ))}
                    <div className="largemenu">
                        <FontAwesomeIcon icon={faBars} onClick={() => setToggleNavlinks(!toggleNavLinks)}/>
                    </div>
                </div> 
                :
                <div className="largemenu">
                    <FontAwesomeIcon icon={faBars} onClick={() => setToggleNavlinks(!toggleNavLinks)}/>
                    <span className="tooltip">Menu</span>
                </div>}
                <div className="mobilemenu">
                    <FontAwesomeIcon icon={faBars} onClick={() => props.setToggleMenu(!props.toggleMenu)}/>
                </div>
            </div>
        </div>
    );
}